export default __webpack_public_path__ + "static/media/seo-images.bd582112.svg";